module.exports = __webpack_public_path__ + "static/media/power-off.689e9a57.svg";